export default "__VITE_ASSET__BOEnsq6G__"